import { PoissonExplorerParams } from './poisson-explorer.component';

export const POISSON_EXPLORER_DEFAULT: PoissonExplorerParams = {
  lambda: 4,
  maxK: 15,
};

export const POISSON_EXPLORER_SMALL_LAMBDA: PoissonExplorerParams = {
  lambda: 1,
  maxK: 10,
};

export const POISSON_EXPLORER_LARGE_LAMBDA: PoissonExplorerParams = {
  lambda: 10,
  maxK: 25,
};

export const POISSON_EXPLORER_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: POISSON_EXPLORER_DEFAULT },
  'small-lambda': { params: POISSON_EXPLORER_SMALL_LAMBDA },
  'large-lambda': { params: POISSON_EXPLORER_LARGE_LAMBDA },
};
